import { TranslationKey } from './../../../../../types/translation/TranslationKey';
import React, { useContext, useState } from 'react';
import { t } from '../../../../../types/translation/Translator';
import { ProductTransaction } from '../../../../../types/productTransaction';
import ProcessOrderTransactionInfoPane from './Panes/ProcessOrderTransactionInfoPane';
import { testIds } from '../../../../../util/identifiers/identifiers.util';
import Modal from '../../../../../VentoryUI/components/common/Modal/Modal';
import { OrderFlowContext } from '../../../../../context/OrderFlowContext';
import { System } from '../../../../../types/system';

interface ProcessOrderTransactionModalInputProps {
  open: boolean;
  setOpen: (value: boolean) => void;
  transaction: ProductTransaction;
  disabled: boolean;
}

export default function ProcessOrderTransactionModal({
  open,
  setOpen,
  transaction,
  disabled = false,
}: ProcessOrderTransactionModalInputProps) {
  const { orderFlows } = useContext(OrderFlowContext);

  if (!open) return null;

  const [error, setError] = useState<string>('');

  const handleClose = () => setOpen(false);

  const flow = orderFlows.get(transaction.flowId);
  if (!flow) return null;

  const current = flow.productTransactionActions.find(action => action.statusId === transaction.statusId);
  if (!current) return null;

  const potentialNextActions = flow.productTransactionActions.filter(action =>
    action.previous.includes(current.statusId),
  );

  const hasStockAction = potentialNextActions.some(
    action =>
      action.productStatusId === System.ProductStatus.increaseId ||
      action.productStatusId === System.ProductStatus.decreaseId,
  );

  const isDisabled = disabled || !hasStockAction;

  return (
    <Modal
      error={error}
      open={open}
      onClose={handleClose}
      title={t(TranslationKey.processTransaction).singular.label}
      testId={testIds.processOrderTransactionModal}
    >
      <ProcessOrderTransactionInfoPane
        input={transaction}
        disabled={isDisabled}
        setError={setError}
        onClose={handleClose}
      />
    </Modal>
  );
}
